export default "__VITE_ASSET__eHz6hWg0__"